
export const EMETTEUR_CODES = {
  "DESC_DETAILLEE1": "SELECT_Z1_DESCRIPTION_DETAILLEE",
  "DESC_DETAILLEE2": "SELECT_Z2_DESCRIPTION_DETAILLEE",
}

export const emetteurZ1 = [
  { code: '1', label: 'SELECT_Z1_PLANCHER_CHAUFFANT', schemaCode: 'P', temperatures: ['30', '35'] },
  { code: '2', label: 'SELECT_Z1_PLANCHER_CHAUFFANT_RAFRAICHISSANT', schemaCode: 'P', temperatures: ['30', '35'] },
  { code: '4', label: 'SELECT_Z1_RADIATEURS', schemaCode: 'R', temperatures: ['40', '45', '50', '55', '60', '65', '70', '75'] },
  { code: '3', label: 'SELECT_Z1_RADIATEURS_DYNAMIQUES', schemaCode: 'V', temperatures: ['30', '35', '40', '45', '50'] },
  { code: '5', label: EMETTEUR_CODES.DESC_DETAILLEE1, schemaCode: 'V', temperatures: [] },
]

export const emetteurZ2 = [
  { code: '1', label: 'SELECT_Z1_PLANCHER_CHAUFFANT', schemaCode: 'P', temperatures: ['30', '35'] },
  { code: '2', label: 'SELECT_Z1_PLANCHER_CHAUFFANT_RAFRAICHISSANT', schemaCode: 'P', temperatures: ['30', '35'] },
  { code: '4', label: 'SELECT_Z1_RADIATEURS', schemaCode: 'R', temperatures: ['40', '45', '50', '55', '60', '65', '70', '75'] },
  { code: '3', label: 'SELECT_Z1_RADIATEURS_DYNAMIQUES', schemaCode: 'V', temperatures: ['30', '35', '40', '45', '50'] },
  { code: '6', label: 'SELECT_Z2_CLIMATISATION', schemaCode: 'V', temperatures: [] },
  { code: '5', label: 'SELECT_Z2_RADIATEURS_ELECTRIQUES', schemaCode: 'R', temperatures: [] },
  { code: '7', label: EMETTEUR_CODES.DESC_DETAILLEE2, schemaCode: 'V', temperatures: [] },
]

export const categorieEmetteurOptions = [
  { code: 'Panneaux acier horizontaux', label: 'CATEGORIE_EMETTEUR_0' },
  { code: 'Panneaux aciers verticaux', label: 'CATEGORIE_EMETTEUR_1' },
  { code: 'Radiateurs en fonte', label: 'CATEGORIE_EMETTEUR_2' },
  { code: "Radiateurs en aluminium horizontaux", label: 'CATEGORIE_EMETTEUR_3' },
  { code: "Convecteurs à eau chaude", label: 'CATEGORIE_EMETTEUR_4' },
  { code: "Radiateurs à tubes plats-horizontaux panneaux décoratifs", label: 'CATEGORIE_EMETTEUR_5' },
  { code: "Radiateurs à tubes plats-verticaux panneaux décoratifs", label: 'CATEGORIE_EMETTEUR_6' },
  { code: "Radiateurs à tubes ronds horizontaux", label: 'CATEGORIE_EMETTEUR_7' },
  { code: "Radiateurs à tubes ronds verticaux", label: 'CATEGORIE_EMETTEUR_8' },
  { code: "Radiateurs sèche serviettes", label: 'CATEGORIE_EMETTEUR_9' },
  { code: "Radiateurs multi colonnes acier", label: 'CATEGORIE_EMETTEUR_10' },
  { code: "Radiateur multi colonnes vertical acier", label: 'CATEGORIE_EMETTEUR_11' },
  { code: "Lamellaire Panneau plissé en acier", label: 'CATEGORIE_EMETTEUR_12' },
];

export const typeEmetteurByCategory: Record<number | string, { code: string; label: string }[]> = {
  "Panneaux acier horizontaux": [
    { code: "Type 10", label: 'TYPE_EMETTEUR_0_0' },
    { code: "Type 11", label: 'TYPE_EMETTEUR_0_1' },
    { code: "Type 20", label: 'TYPE_EMETTEUR_0_2' },
    { code: "Type 21", label: 'TYPE_EMETTEUR_0_3' },
    { code: "Type 22", label: 'TYPE_EMETTEUR_0_4' },
    { code: "Type 32", label: 'TYPE_EMETTEUR_0_5' },
    { code: "Type 33", label: 'TYPE_EMETTEUR_0_6' },
  ],

  "Panneaux aciers verticaux": [
    { code: "Type 10", label: 'TYPE_EMETTEUR_1_0' },
    { code: "Type 11", label: 'TYPE_EMETTEUR_1_1' },
    { code: "Type 20", label: 'TYPE_EMETTEUR_1_2' },
    { code: "Type 21", label: 'TYPE_EMETTEUR_1_3' },
    { code: "Type 22", label: 'TYPE_EMETTEUR_1_4' },
  ],

  "Radiateurs en fonte": [
    { code: "2 col", label: 'TYPE_EMETTEUR_2_0' },
    { code: "3 col", label: 'TYPE_EMETTEUR_2_1' },
    { code: "4 col", label: 'TYPE_EMETTEUR_2_2' },
    { code: "5 col", label: 'TYPE_EMETTEUR_2_3' },
    { code: "6 col", label: 'TYPE_EMETTEUR_2_4' },
  ],

  "Radiateurs en aluminium horizontaux": [
    { code: "Pf = 80", label: 'TYPE_EMETTEUR_3_0' },
    { code: "Pf = 95", label: 'TYPE_EMETTEUR_3_1' },
    { code: "Pf = 140", label: 'TYPE_EMETTEUR_3_2' },
  ],

  "Convecteurs à eau chaude": [
    { code: "Pf = 120", label: 'TYPE_EMETTEUR_4_0' },
    { code: "Pf = 170", label: 'TYPE_EMETTEUR_4_1' },
    { code: "Pf = 220 échangeur simple", label: 'TYPE_EMETTEUR_4_2' },
    { code: "Pf = 120 échangeur double", label: 'TYPE_EMETTEUR_4_3' },
    { code: "Pf = 170 échangeur double", label: 'TYPE_EMETTEUR_4_4' },
    { code: "Pf = 220 echangeur double", label: 'TYPE_EMETTEUR_4_5' },
  ],

  "Radiateurs à tubes plats-horizontaux panneaux décoratifs": [
    { code: "Simple mais sans ailettes", label: 'TYPE_EMETTEUR_5_0' },
    { code: "Simple avec ailette", label: 'TYPE_EMETTEUR_5_1' },
    { code: "Double", label: 'TYPE_EMETTEUR_5_2' },
  ],

  "Radiateurs à tubes plats-verticaux panneaux décoratifs": [
    { code: "Simple", label: 'TYPE_EMETTEUR_6_0' },
    { code: "Double", label: 'TYPE_EMETTEUR_6_1' },
  ],

  "Radiateurs à tubes ronds horizontaux": [
    { code: "Simple", label: 'TYPE_EMETTEUR_7_0' },
    { code: "Double", label: 'TYPE_EMETTEUR_7_1' },
  ],

  "Radiateurs à tubes ronds verticaux": [
    { code: "Simple", label: 'TYPE_EMETTEUR_8_0' },
    { code: "Double", label: 'TYPE_EMETTEUR_8_1' },
  ],

  "Radiateurs multi colonnes acier": [
    { code: "2 colonnes", label: 'TYPE_EMETTEUR_9_0' },
    { code: "3 colonnes", label: 'TYPE_EMETTEUR_9_1' },
    { code: "4 colonnes", label: 'TYPE_EMETTEUR_9_2' },
  ],

  "Lamellaire Panneau plissé en acier": [
    { code: "Pf = 65", label: 'TYPE_EMETTEUR_10_0' },
    { code: "Pf = 95", label: 'TYPE_EMETTEUR_10_1' },
    { code: "Pf = 120", label: 'TYPE_EMETTEUR_10_2' },
  ],
};

export const getRadiatorClassI18nCode = (radiatorClass?: string | null): string | null => {
  if (!radiatorClass) return null;
  const option = categorieEmetteurOptions.find((item) => item.code === radiatorClass);
  if (option?.label) return option.label;
  if (radiatorClass.startsWith('CATEGORIE_EMETTEUR_')) return radiatorClass;
  return null;
};

export const getTypeEmetteurI18nCode = (
  radiatorClass?: string | null,
  radiatorModel?: string | null,
): string | null => {
  if (!radiatorModel) return null;
  if (radiatorModel.startsWith('TYPE_EMETTEUR_')) return radiatorModel;

  if (radiatorClass) {
    const options = typeEmetteurByCategory[radiatorClass] || [];
    const found = options.find((item) => item.code === radiatorModel);
    if (found?.label) return found.label;
  }

  return null;
};

export const houseTypes = [
  { value: "Maison", text: 'HOUSE' },
  { value: "Appartement", text: 'FLAT' },
]

export const atticTypes = [
  { code: "0", label: 'INSULATION_CEILING_ATTIC_1' },
  { code: "1", label: 'INSULATION_CEILING_ATTIC_2' },
  { code: "2", label: 'INSULATION_CEILING_ATTIC_3' },
];

export const emetteurCount = [{ value: "1", text: '1' }, { value: "2", text: '2' }, { value: "3", text: '3' }, { value: "4", text: '4' }, { value: "5", text: '5' }, { value: "6", text: '6' }, { value: "7", text: '7' }, { value: "8", text: '8' }, { value: "9", text: '9' }, { value: "10", text: '10' }]

export function getEmetteursByZone(index: any) {
  return index <= 0 ? emetteurZ1 : emetteurZ2
}

export const insulationWork = [
  { code: '0', label: 'NO' },
  { code: '1', label: 'YES' },
]

export const insulation = [
  { code: '1', label: 'SELECT_WI_NO' },
  { code: '2', label: 'SELECT_WI_AVANT1988' },
  { code: '3', label: 'SELECT_WI_ENTRE_1989ET2000' },
  { code: '4', label: 'SELECT_WI_ENTRE2000ET2010' },
  { code: '5', label: 'SELECT_WI_APRES2010' },
]

export const actualSystem = [
  { code: '1', label: 'CHAUDIERE_FIOUL' },
  { code: '2', label: 'CHAUDIERE_GAZ' },
  { code: '3', label: 'CHAUDIERE_PROPANE' },
]

export const withECS = [
  { code: '1', label: 'YES' },
  { code: '0', label: 'NO' },
]

export const systemAge = [
  { code: '1', label: 'SUP_10_YEARS' },
  { code: '2', label: 'INF_10_YEARS' },
]

export const temperature = [
  { code: '15', label: '15' },
  { code: '16', label: '16' },
  { code: '17', label: '17' },
  { code: '18', label: '18' },
  { code: '19', label: '19' },
  { code: '20', label: '20' },
  { code: '21', label: '21' },
  { code: '22', label: '22' },
  { code: '23', label: '23' },
  { code: '24', label: '24' },
  { code: '25', label: '25' },
]

export const invoiceNbOccupants = [
  { code: '1', label: '1' },
  { code: '2', label: '2' },
  { code: '3', label: '3' },
  { code: '4', label: '4' },
  { code: '5', label: '5' },
  { code: '6', label: '6' },
]

export const cool_temperature = [
  { code: '24', label: '24' },
  { code: '25', label: '25' },
  { code: '26', label: '26' },
  { code: '27', label: '27' },
  { code: '28', label: '28' },
]

export const cool_nbPeoples = [
  { code: '1', label: '1' },
  { code: '2', label: '2' },
  { code: '3', label: '3' },
  { code: '4', label: '4' },
  { code: '5', label: '5' },
  { code: '6', label: '6' },
]

export const cool_inertia = [
  { code: '0', label: 'COOL_INERTIA_LIGHT' },
  { code: '1', label: 'COOL_INERTIA_AVG' },
  { code: '2', label: 'COOL_INERTIA_HEAVY' },
]

export const cool_location = [
  { code: '0', label: 'YES' },
  { code: '1', label: 'NO' },
]

export const cool_mitoyen = [
  { code: '0', label: 'NO' },
  { code: '1', label: 'YES' },
]

export const cool_orientation = [
  { code: '1', label: 'NORTH' },
  { code: '0', label: 'NORTH_WEST' },
]

export const cool_occultant = [
  { code: '0', label: 'NO' },
  { code: '1', label: 'INTERIOR' },
  { code: '2', label: 'EXTERIOR' },
]

export const typologies = [
  { code: '0', label: 'SELECT_TYPO_IND' },
  { code: '1', label: 'SELECT_TYPO_SPLIT' },
]

export const typologiesWithMonobloc = [
  { code: '0', label: 'SELECT_TYPO_IND' },
  { code: '1', label: 'SELECT_TYPO_SPLIT' },
  { code: '2', label: 'SELECT_TYPO_MONOBLOC' },
]

export const captages = [
  { code: '1', label: 'SELECT_CAPT_NAPPE' },
  { code: '2', label: 'SELECT_CAPT_VERT' },
  { code: '3', label: 'SELECT_CAPT_HORZ' },
]

export const utilisations = [
  // { code: '1', label: 'SELECT_UTI_BATI2012' },
  { code: '2', label: 'SELECT_UTI_RENO' },
]

export const energies_rt2012 = [
  { code: 'gaz', label: 'SELECT_NRG_GAZ' },
  { code: 'propane', label: 'SELECT_NRG_PROPANE' },
]

export const energies = [
  { code: 'fioul', label: 'SELECT_NRG_FIOUL' },
  { code: 'gaz', label: 'SELECT_NRG_GAZ' },
  { code: 'propane', label: 'SELECT_NRG_PROPANE' },
]

export const alimentations = [
  { code: '1', label: 'SELECT_ALIM_MONO' },
  { code: '2', label: 'SELECT_ALIM_TRI' },
]
export const alimentations_ind = [{ code: '0', label: 'SELECT_ALIM_IND' }]

export const abonnementsMono = [{ code: '1', label: 'SELECT_ABO_PLEINT' }]

export const abonnementsMulti = [
  { code: '1', label: 'SELECT_ABO_PLEINT' },
  { code: '2', label: 'SELECT_ABO_1P' },
  { code: '3', label: 'SELECT_ABO_2P' },
]

export const releveChaudiere = [
  { code: 'chaudiere', label: 'YES' },
  { code: 'sans', label: 'NO' },
]

export const anneesChaudiere = [
  { code: 'plus de 10 ans', label: 'SUP_10_YEARS' },
  { code: 'moins de 10 ans', label: 'INF_10_YEARS' },
]

export const typesChaudiere = [
  { code: 'standard', label: 'SELECT_TYPEC_STD' },
  { code: 'basse temperature', label: 'SELECT_TYPEC_BASSET' },
  { code: 'condensation', label: 'SELECT_TYPEC_COND' },
]

export const energiesChaudiere = [
  { code: 'propane', label: 'SELECT_NRGC_PROPANE' },
  { code: 'gaz', label: 'SELECT_NRGC_GAZ' },
  { code: 'fioul', label: 'SELECT_NRGC_FIOUL' },
  { code: 'electrique', label: 'SELECT_NRGC_ELEC' },
]

export const nbOccupants = [
  { code: '1', label: '1' },
  { code: '2', label: '2' },
  { code: '3', label: '3' },
  { code: '4', label: '4' },
  { code: '5', label: '5' },
  { code: '6', label: '6' },
]


export const IDU_types_classique = { paramCode: '0', code: 'classique', label: 'IDU_TYPE_1S' } //Module hydraulique 1 service classique
export const IDU_type_compact = { paramCode: '1', code: 'compact', label: 'IDU_TYPE_CB' } //Réutilisation hydraulique existant (module compact )


export const IDU_type_integree = [
  { paramCode: '0', code: 'sol', label: 'IDU_TYPE_DUO' },
  { paramCode: '1', code: 'mural', label: 'IDU_TYPE_DUOM' },
  { paramCode: '2', code: 'ind', label: 'IDU_TYPE_DUOI' },
]

export const habitatLevel = [
  { code: "1", label: 'HABITAT_LEVEL_0' },
  { code: "2", label: 'HABITAT_LEVEL_1' },
  { code: "3", label: 'HABITAT_LEVEL_2' },
  { code: "4", label: 'HABITAT_LEVEL_3' },
]

export const habitatOwnership = [
  { code: "0", label: 'HABITAT_OWNERSHIP_0' },
  { code: "1", label: 'HABITAT_OWNERSHIP_1' },
  { code: "2", label: 'HABITAT_OWNERSHIP_2' },
  { code: "3", label: 'HABITAT_OWNERSHIP_3' },
  { code: "4", label: 'HABITAT_OWNERSHIP_4' },
]

export const installationWallTypes = [
  { code: "0", label: 'INSULATION_WALL_0' },
  { code: "1", label: 'INSULATION_WALL_1' },
  { code: "2", label: 'INSULATION_WALL_2' },
  { code: "3", label: 'INSULATION_WALL_3' },
  { code: "4", label: 'INSULATION_WALL_4' },
  { code: "5", label: 'INSULATION_WALL_5' },
  { code: "6", label: 'INSULATION_WALL_6' },
  { code: "7", label: 'INSULATION_WALL_7' },
  { code: "8", label: 'INSULATION_WALL_8' },
  { code: "9", label: 'INSULATION_WALL_9' },
]

export const insulationCeilingTypes = [
  { code: "0", label: 'UNKNOWN' },
  { code: "1", label: 'INSULATION_CEILING_TYPE_1' },
  { code: "2", label: 'INSULATION_CEILING_TYPE_2' },
  { code: "3", label: 'INSULATION_CEILING_TYPE_3' },
  { code: "4", label: 'INSULATION_CEILING_TYPE_4' }
]


export const insulationFloorTypes = [
  { code: "0", label: 'INSULATION_FLOOR_TYPE_1' },
  { code: "1", label: 'INSULATION_FLOOR_TYPE_2' },
  { code: "2", label: 'INSULATION_FLOOR_TYPE_3' },
  { code: "3", label: 'INSULATION_FLOOR_TYPE_4' },
  { code: "4", label: 'INSULATION_FLOOR_TYPE_5' },
  { code: "5", label: 'INSULATION_FLOOR_TYPE_6' },
  { code: "6", label: 'INSULATION_FLOOR_TYPE_7' }
]


export const insulationFloorOnTypes = [
  { code: "0", label: 'INSULATION_FLOOR_ON_1' },
  { code: "1", label: 'INSULATION_FLOOR_ON_2' },
  { code: "2", label: 'INSULATION_FLOOR_ON_3' },
  { code: "3", label: 'INSULATION_FLOOR_ON_4' },
]

export const insulationOpeningTypes = [
  { value: "0", text: 'INSULATION_OPENING_TYPE_1' },
  { value: "1", text: 'INSULATION_OPENING_TYPE_2' },
  // { value: "2", text: 'INSULATION_OPENING_TYPE_3' },
]

export const insulationOpeningMat = [
  { value: "0", text: 'INSULATION_OPENING_MAT_1' },
  { value: "1", text: 'INSULATION_OPENING_MAT_2' },
  { value: "2", text: 'INSULATION_OPENING_MAT_3' },
]

export const insulationOpeningDoorClass = [
  { value: "A", text: 'INSULATION_OPENING_DOOR_CLASS_A' },
  { value: "B", text: 'INSULATION_OPENING_DOOR_CLASS_B' },
  { value: "C", text: 'INSULATION_OPENING_DOOR_CLASS_C' },
  { value: "D", text: 'INSULATION_OPENING_DOOR_CLASS_D' },
  { value: "E", text: 'INSULATION_OPENING_DOOR_CLASS_E' },
  { value: "F", text: 'INSULATION_OPENING_DOOR_CLASS_F' },
  { value: "inconnu", text: 'INSULATION_OPENING_DOOR_CLASS_UNKNOWN' },
]

export const insulationVentilationTypes = [
  { value: "0", text: 'INSULATION_VENTILATION_TYPE_1' },
  { value: "1", text: 'INSULATION_VENTILATION_TYPE_2' },
  { value: "2", text: 'INSULATION_VENTILATION_TYPE_3' },
  { value: "3", text: 'INSULATION_VENTILATION_TYPE_4' },
  { value: "4", text: 'INSULATION_VENTILATION_TYPE_5' },
  { value: "5", text: 'INSULATION_VENTILATION_TYPE_6' },
]
